import { getLogger, type ILogger } from '@trimble/logging';

/** Shared log namespace for geospatial services, transformer, and controller. */
export const GEOSPATIAL_LOG_SCOPE = 'Geospatial';

export type GeospatialLogger = ILogger;

export function childGeospatialLogger(parent: ILogger, name: string): ILogger {
  return parent.createNamedLogger(name);
}

/** Pretty-print an API response body at debug level. */
export function logPrettyResponse(
  logger: ILogger,
  label: string,
  data: unknown
): void {
  const jsonIndent = 2;
  logger.debug(
    `${label} response body\n${JSON.stringify(data, null, jsonIndent)}`
  );
}

/** Legacy singleton logger when the host has not supplied an {@link ILogger}. */
export function fallbackGeospatialLogger(name: string): ILogger {
  const legacy = getLogger();
  const prefix = `[${GEOSPATIAL_LOG_SCOPE}:${name}]`;
  return {
    name: `${GEOSPATIAL_LOG_SCOPE}:${name}`,
    createNamedLogger: (childName: string): ILogger =>
      fallbackGeospatialLogger(`${name}.${childName}`),
    setProjectContext: (): void => undefined,
    debug: (message, context, error): void =>
      legacy.debug(`${prefix} ${message}`, context, error),
    info: (message, context, error): void =>
      legacy.info(`${prefix} ${message}`, context, error),
    warn: (message, context, error): void =>
      legacy.warn(`${prefix} ${message}`, context, error),
    error: (message, context, error): void =>
      legacy.error(`${prefix} ${message}`, context, error),
  };
}
